import {useSelector} from 'react-redux';

import appConfig from '../../config/appConfig';
import FWU_TARGET_TYPES from '../../enums/iot/fwuTargetTypes';
import deviceTypesService from '../../services/device/deviceTypesService';
import storageService from '../../services/storage/storageService';
import {selectFirmware_124_4_4_RelatedTargetSerialNumber, selectIotDeviceType} from '../../state/selectors/iotDevice';
import useHolderControlFwVersion from '../useHolderControlFwVersion';

const useFirmwareReleaseNotes = () => {
    const isFirmwareReleaseNotesEnabled = appConfig.getIsFirmwareReleaseNotesEnabled();
    const isFirmwareReleaseNotesBannerVisible = appConfig.getIsFirmwareReleaseNotesBannerEnabled();

    const deviceType = useSelector(selectIotDeviceType);
    const holderVersions = useHolderControlFwVersion();
    const isP1V41 = deviceTypesService.isP1V41(deviceType);
    const isMono = deviceTypesService.isMono(deviceType);
    const FW_VERSION = '124.4.4';

    const serialNumber = useSelector(selectFirmware_124_4_4_RelatedTargetSerialNumber);

    const getFirmwareReleaseNotesData = () => {
        return storageService.getFirmwareReleaseNotesDataFromLocalStorageBySerialNumber(serialNumber);
    };

    const setFirmwareReleaseNotesDataIfNeeded = (fwuTarget, fwVersion) => {
        if (
            fwuTarget !== FWU_TARGET_TYPES.HOLDER_DEVICE ||
            fwVersion !== FW_VERSION ||
            !isFirmwareReleaseNotesBannerVisible
        )
            return;

        storageService.setFirmwareReleaseNotesDataToLocalStorageBySerialNumber({
            serialNumber,
            isFwUpgraded: true,
        });
    };
    const setWasShownFwu = () => {
        storageService.setFirmwareReleaseNotesDataToLocalStorageBySerialNumber({
            serialNumber,
            wasShownFwu: true,
        });
    };

    const setWasReleaseNotesShown = () => {
        storageService.setFirmwareReleaseNotesDataToLocalStorageBySerialNumber({
            serialNumber,
            wasReleaseNotesShown: true,
        });
    };

    const removeFirmwareReleaseNotesBannerData = () => {
        storageService.removeFirmwareReleaseNotesData(serialNumber, ['isFwUpgraded', 'wasReleaseNotesShown']);
    };

    const fwVersionAvailable = holderVersions?.some((v) => v === FW_VERSION);

    if (!isFirmwareReleaseNotesEnabled || !isP1V41 || isMono) {
        return {};
    }

    return {
        isFirmwareReleaseNotesAvailable: true,
        isFirmwareReleaseNotesBannerVisible,
        fwVersionAvailable,
        setWasShownFwu,
        getFirmwareReleaseNotesData,
        setFirmwareReleaseNotesDataIfNeeded,
        setWasReleaseNotesShown,
        removeFirmwareReleaseNotesBannerData,
    };
};

export default useFirmwareReleaseNotes;
